import { Box, Grid } from '@mui/material';
import { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import NotEmployed from './NotEmployed';
import LeadGenerationContext from '../../../context/LeadGenerationContext';
import { emplomentStyles as classes } from './EmploymentStyles';
import { ProductUIStyles } from '../StepTwo/ProductUIStyles';
import Employed from './Employed';
import Retired from './Retired';
import SelfEmployed from './SelfEmployed';
import {
  LIBRE_AHORRA_BUNDLE,
  ELITE_ACCOUNT_EN,
  EMPLOYED,
  SELF_EMPLOYED,
  NOT_EMPLOYED,
  RETIRED,
  EMP_STATUS_QUE,
  MANDATORY_FIELD_ERR,
  PROGRESA_CONTIGO,
  EMP_STATUS_QUE_PROG,
} from '../../../constants';
import { productMapping } from '../../../services/productMapping';
import EmpStatusCardComp from './EmpStatusCardComp';
import { isCDproduct } from '../../commonCode';

function Employment({ isBundleCompliance = false }) {
  const [employmentStatus, setEmploymentStatus] = useState('');
  const { t } = useTranslation();
  const leadGenerationContext = useContext(LeadGenerationContext);
  const styledClasses = ProductUIStyles(leadGenerationContext?.theme);
  const handleChange = (e) => {
    leadGenerationContext.setIsScreenFourDirty(true);
    leadGenerationContext.setIsScreenFiveDirty(true);
    leadGenerationContext.setIsFundingScreenDirty(true);
    setEmploymentStatus(e.target.value);
    leadGenerationContext.setEmploymentInformation({
      employmentStatus: e.target.value,
    });
    leadGenerationContext.setEmploymentInformationErrors({});
    if (e.target.value.length === 0) {
      leadGenerationContext.setEmploymentInformationErrors({
        [e.target.name]: MANDATORY_FIELD_ERR,
      });
    } else {
      leadGenerationContext.setEmploymentInformationErrors({
        [e.target.name]: '',
      });
    }
  };
  const handleCardClick = (e, status) => {
    leadGenerationContext.setActiveEmploymentStatus(status);
    leadGenerationContext.setEmploymentInformation({
      employmentStatus: status,
    });
    if (!status) {
      leadGenerationContext.setEmploymentInformationErrors({
        [e.target.name]: MANDATORY_FIELD_ERR,
      });
    } else {
      leadGenerationContext.setEmploymentInformationErrors({
        [e.target.name]: '',
      });
    }
  };

  const getEmploymentStatus = () => {
    if (leadGenerationContext?.employmentInformation?.employmentStatus) {
      return leadGenerationContext.employmentInformation.employmentStatus;
    }
    return employmentStatus;
  };

  return (
    <div role="form" aria-describedby="employementAriaLabel">
      <Grid size={{ xs: 12 }} style={{ marginBottom: isBundleCompliance ? '24px' : '14px' }}>
        <Box
          component="span"
          id="employementAriaLabel"
          sx={
            isBundleCompliance
              ? {
                  ...styledClasses.empStatusBundle,
                  color: leadGenerationContext?.theme?.palette?.primary?.main,
                }
              : styledClasses.quesTitleStyle
          }
          aria-label={t(EMP_STATUS_QUE, {
            defaultValue: EMP_STATUS_QUE,
            nsSeparator: '|',
          })}
        >
          {productMapping(leadGenerationContext.productName) === ELITE_ACCOUNT_EN ||
          productMapping(leadGenerationContext.productName) === 'Libre' ||
          productMapping(leadGenerationContext.productName) === 'Ahorra' ||
          productMapping(leadGenerationContext.productName) === LIBRE_AHORRA_BUNDLE
            ? t('What is your employment Prog', {
                defaultValue: EMP_STATUS_QUE_PROG,
                nsSeparator: '|',
              })
            : t(EMP_STATUS_QUE, {
                defaultValue: EMP_STATUS_QUE,
                nsSeparator: '|',
              })}
        </Box>
      </Grid>

      <Grid size={12}>
        {leadGenerationContext.productName === PROGRESA_CONTIGO ? (
          <Grid container size={12}>
            <Employed />
          </Grid>
        ) : (
          <EmpStatusCardComp
            handleCardClick={handleCardClick}
            isBundleCompliance={isBundleCompliance}
          />
        )}
        {productMapping(leadGenerationContext.productName) === PROGRESA_CONTIGO ? (
          ''
        ) : (
          <Grid sx={!isBundleCompliance && { display: 'ruby' }}>
            {leadGenerationContext.employmentInformation?.employmentStatus &&
              leadGenerationContext.employmentInformation?.employmentStatus === EMPLOYED && (
                <Employed isBundleCompliance={isBundleCompliance} />
              )}
            {leadGenerationContext.employmentInformation?.employmentStatus &&
              leadGenerationContext.employmentInformation?.employmentStatus === SELF_EMPLOYED && (
                <SelfEmployed isBundleCompliance={isBundleCompliance} />
              )}
            {leadGenerationContext.employmentInformation?.employmentStatus &&
              leadGenerationContext.employmentInformation?.employmentStatus === RETIRED && (
                <Retired isBundleCompliance={isBundleCompliance} />
              )}
            {leadGenerationContext.employmentInformation?.employmentStatus &&
              leadGenerationContext.employmentInformation?.employmentStatus === NOT_EMPLOYED && (
                <NotEmployed isBundleCompliance={isBundleCompliance} />
              )}
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default Employment;

Employment.propTypes = {
  isBundleCompliance: PropTypes.bool,
};
